import Icons from 'components/icons';
import { forwardRef } from 'react';
import Select, { GroupBase, Props as SelectProps, StylesConfig, components } from 'react-select';
import styled, { useTheme } from 'styled-components';

const customStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  container: (provided, state) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
  }),
  menu: (provided) => ({
    ...provided,
    width: '100%',
  }),
  option: (provided, state: any) => ({
    ...provided,
    fontSize: 14,
    whiteSpace: 'nowrap',
  }),
  placeholder: (provided) => ({
    ...provided,
    position: 'static',
    transform: 'none',
    fontSize: 14,
  }),
  singleValue: (provided) => ({
    ...provided,
    position: 'static',
    transform: 'none',
    fontSize: 14,
    whiteSpace: 'pre-wrap',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    paddingRight: 5,
  }),
};

// const DropdownIndicator = (props: DropdownIndicatorProps<unknown, true>) => {
//   return (
//     <components.DropdownIndicator {...props}>
//       <Icons icon="chevronDown" />
//     </components.DropdownIndicator>
//   );
// };

const Arrow = styled(Icons)`
  width: 22px;
  color: ${({ theme }) => theme.colors.primary_200};
`;

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <Arrow icon="chevronDown" />
    </components.DropdownIndicator>
  );
};

const SelectTag = forwardRef<any, SelectProps>(({ isSearchable = false, noOptionsMessage = () => 'Sem opções', ...props }, ref) => {
  const { colors } = useTheme();
  return (
    <Select
      isSearchable={isSearchable}
      components={{ DropdownIndicator }}
      ref={ref}
      noOptionsMessage={noOptionsMessage}
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          primary: colors.primary_400,
          primary75: colors.primary_200,
          primary50: colors.gray_100,
          primary25: colors.gray_100,
        },
      })}
      styles={customStyles}
      {...props}
    />
  );
});

export default SelectTag;
